import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/home-view.vue';
import { Constants } from '@fibl/oxs-common';
import { useGlobalStore } from '@/stores/global';
import AdminRoutes from './admin';
import OxsRoutes from './oxs';
import OxsSelectRoutes from './oxs-select';
import RdbRoutes from './rdb';
import { ETrackerCode } from '@/util/env';

function setBaseTag(prefix: string) {
	let url = new URL(`${document.location.protocol}//${document.location.host}${prefix}`);
	let baseTag = document.getElementsByTagName('base')[0];
	if (!baseTag) {
		console.warn('base tag not found');
		return;
	}
	baseTag.setAttribute('href', url.href);
	console.log('base tag set', baseTag);
}

export async function initRouter(prefix: string, websiteCode: Constants.WebConstant) {
	setBaseTag(prefix);
	let routes = [
		{
			path: '/',
			name: 'home',
			component: HomeView,
		},
	];
	switch (websiteCode) {
		case Constants.WEB_ADMIN: {
			routes = routes.concat(AdminRoutes as any);
			break;
		}
		case Constants.WEB_OXS: {
			routes = routes.concat(OxsRoutes as any);
			break;
		}
		case Constants.WEB_OXS_SELECT: {
			routes = routes.concat(OxsSelectRoutes as any);
			break;
		}
		case Constants.WEB_RDB: {
			routes = routes.concat(RdbRoutes as any);
			break;
		}
	}
	const router = createRouter({
		history: createWebHistory(prefix),
		routes,
	});
	router.beforeEach((to, from, next) => {
		if (to.name !== from.name) {
			const store = useGlobalStore();
			//reset back route in adm
			store.websiteStore.setBackRoute(null);
			//clear relatd cache
			// store.relatedStore.reset();
		}
		return next();
	});
	router.beforeEach((to, from, next) => {
		const store = useGlobalStore();
		store.relatedStore.clearStale();
		store.offerlistStore.reset();
		return next();
	});
	router.afterEach((to) => {
		const w = window as any;
		if ('_etracker' in w && typeof w._etracker === 'object' && ETrackerCode) {
			w.et_eC_Wrapper({ et_et: ETrackerCode });
		}
	});
	return router;
}
